// Copyright (c) 2026 AesirX.io Ltd. All rights reserved.
// This source code is proprietary and confidential.
// See LICENSE.md for licensing terms.
/**
 * Sprint 25.8.0 — Enum Translation Layer
 *
 * Translates enum values (e.g. severity, priority, status, risk_level)
 * using the i18n common.enum_{category}.{value} key path.
 * Falls back to a human-readable version of the raw value.
 */
export function translateEnum(category, value, t) {
    const enumKey = `enum_${category}`;
    const normalizedValue = value.replace(/\s+/g, '_');
    const result = t?.common?.[enumKey]?.[normalizedValue] ?? t?.common?.[enumKey]?.[value];
    return typeof result === 'string' ? result : value.replace(/_/g, ' ');
}
//# sourceMappingURL=translate-enum.js.map